import * as React from 'react';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CustomSelect from "../CustomComponents/CustomSelect";
import moment from 'moment';
import FormHelperText from '@mui/material/FormHelperText';

export default function CostCenterDialog({ handleDialogCallback }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [siteChoices, setSiteChoices] = React.useState([])

    const initialValues = {
        CommonName: '',
        SiteID: '',
        CostCenter: '',
        Name: '',
        CostCenterDateLock: '',
        IsActive: false
    };

    const validFormSchema = Yup.object({
        CostCenter: Yup
            .string('Enter a Cost Center ID')
            .required('Cost Center is Required'),
        Name: Yup
            .string('Enter a name')
            .required('Cost Center Name is Required'),
        SiteID: Yup
            .string('Enter a Site to attach this Cost Center')
            .required('Linked Site is required'),
        CommonName: Yup
            .string('Enter a common name for this cost center')
            .required('Common name is required'),
        CostCenterDateLock: Yup
            .string('Enter an Lock Date for this cost center')
            .required('Lock Date is required "mm/dd/yyyy"'),
        IsActive: Yup
            .boolean()
    })
    
    const onTrigger = React.useCallback((values) => {
        const msg = {
            CommonName: values.CommonName,
            CostCenter: values.CostCenter,
            Name: values.Name,
            SiteID: values.SiteID,
            CostCenterDateLock: moment.utc(values.CostCenterDateLock),
            IsActive: values.IsActive
        };

        handleDialogCallback(msg);
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const setChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.Name, value: choice.ID }))
        setSiteChoices(choices)
    }

    React.useEffect(() => {
        if (refresh) {
            fetch('api/site/dropdown', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setChoices(json));
            setRefresh(false);
        }
    })

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add Cost Center
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">                
                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Cost Center
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Cost Center Info:</DialogTitle>
                                <div>
                                    <FormControl  sx={{ m: 1, width: 240 }}>                                        
                                        <TextField
                                            name="CostCenter"
                                            variant="outlined"
                                            id="outlined-CostCenter"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.CostCenter}
                                            error={props.touched.CostCenter && Boolean(props.errors.CostCenter)}
                                            helperText={props.touched.CostCenter && props.errors.CostCenter}
                                            label="Cost Center"
                                        />
                                    </FormControl>
                    
                                    <FormControl  sx={{ m: 1, width: 240 }}>                                       
                                        <TextField
                                            name="Name"
                                            variant="outlined"
                                            id="outlined-Name"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Name}
                                            error={props.touched.Name && Boolean(props.errors.Name)}
                                            helperText={props.touched.Name && props.errors.Name}
                                            label="Name"
                                        />
                                    </FormControl>
                                    <FormControl  sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="CommonName"
                                            variant="outlined"
                                            id="outlined-CostCenter"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.CommonName}
                                            error={props.touched.CommonName && Boolean(props.errors.CommonName)}
                                            helperText={props.touched.CommonName && props.errors.CommonName}
                                            label="Common Name"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl  sx={{ m: 1, width: 240 }}>
                                        <InputLabel htmlFor="outlined-Name">Site Name</InputLabel>
                                        <CustomSelect
                                            name="SiteID"
                                            id="outlined-costCenter"
                                            options={siteChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.SiteID}
                                            error={props.touched.SiteID && Boolean(props.errors.SiteID)}
                                            helperText={props.touched.SiteID && props.errors.SiteID}
                                            label="SiteID"
                                        />
                                         {props.touched.SiteID && Boolean(props.errors.SiteID) &&
													<FormHelperText error={true}>{props.errors.SiteID}</FormHelperText>}
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl  sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="CostCenterDateLock"
                                            variant="outlined"
                                            id="outlined-CostCenter"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.CostCenterDateLock}
                                            error={props.touched.CostCenterDateLock && Boolean(props.errors.CostCenterDateLock)}
                                            helperText={props.touched.CostCenterDateLock && props.errors.CostCenterDateLock}
                                            label="Lock Date"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            name="IsActive"
                                            label="Active"
                                            control={<Checkbox checked={props.values.IsActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                            
            </Dialog>
        </div>
    );
}